<template>
	<TheHeader></TheHeader>
	
	<div class="container-fluid">
		<div class="container">
			<form name="form">
				<div class="contain row">
					<TheSidebar></TheSidebar>
					
					<div class="page-container card col-md-8">
						<ThePageHeader @import-event="importFile" @export-event="exportFile" :renderImport="!isLoading" :renderExport="!isLoading" :isImporting="isImporting" :isExporting="isExporting"></ThePageHeader>
						
						<div class="row" v-if="pageError == ''">
							
							<div class="row p-3">
								<div class="col-md-6">
									<Button class="p-button-sm" @click="add" label="Create New Configuration"/>
								</div>
							</div>
							
							<div class="row p-3 pb-0">
								<label><b>Search existing Configuration by:</b></label>
							</div>
							
							
							<div class="row p-3">
                                <div class="col-md-4">
                                    <InputText class="p-inputtext" type="text" maxlength="100" placeholder="Name" v-model="filterNameModel.value" />
                                </div>
								
								<div class="col-md-4">
									<Dropdown :options="exchangeRate" optionLabel="name" optionValue="value" placeholder="Exchange Rate" v-model="filterExchangeRateModel.value" />
								</div>

								<div class="col-md-4">
									<Dropdown :options="getActiveStatuses(statuses)" optionLabel="name" optionValue="value" placeholder="Status" v-model="filterStatusModel.value" />
								</div>
							</div>	
								
							<div class="row p-3">
								<div class="col-md-5 d-flex align-items-center">
									<Button class="p-button-sm" @click="find(1)" label="Search"/>
									<span class="p-1"></span>
									<Button class="p-button-sm p-button-secondary" @click="reset" label="Reset"/>
								</div>
									
								<div class="col-md-7">
									<Paginator :first="paginator" :pageLinkSize="3" :rows="pagination.itemsPerPage" :totalRecords="pagination.totalItems" @page="find($event.page + 1)" v-if="pagination.currentPage != 0" />
								</div>
							</div>
							
							<div class="row">
								<div class="col-md-12 p-4">
									<table class="p-datatable p-component p-datatable-hoverable-rows align-middle mb-0 w-12">
										<thead class="p-datatable-thead">
											<tr>
												<th style="width: 8%;">#</th>
												<th style="width: 42%; cursor: pointer;" @click="sort('x.name')">Name <span class="pi" :class="[sortingModel.columnName == 'x.name' ? (sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']"></span></th>
												<th style="width: 35%; cursor: pointer;" @click="sort('x.exchangeRate')">Exchange Rate <span class="pi" :class="[sortingModel.columnName == 'x.exchangeRate' ? (sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']"></span></th>
												<th style="width: 15%;" class="text-center">Status</th>
											</tr>
										</thead>
										<tbody class="p-datatable-tbody" v-if="!isLoading">
											<tr v-for="(eliminationSetting, index) in pagination.eliminationSettings" :key="index" v-on:click="view(eliminationSetting)">
												<td>{{((pagination.currentPage - 1) * pagination.itemsPerPage) + index + 1}}</td>
												<td>{{eliminationSetting.name}}</td>
												<td>{{eliminationSetting.exchangeRate}}</td>
												<td class="text-center">
													<Badge class="mr-2" :class="[eliminationSetting.status == 'Active' ? 'p-badge-success' : 'p-badge-danger']" :value="eliminationSetting.status"></Badge>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
								
								<div class="error-no-record" v-if="!isLoading && pagination.eliminationSettings.length == 0">
									<FontAwesomeIcon :icon="['fas', 'image']" size="2x" />
									<h6><span>No Record Found</span></h6>
								</div>
								
								<TheTableLoading v-if="isLoading"></TheTableLoading>
							</div>
						</div>

						<TheInvalidImportDialog title="Company" :visible="isDialogVisible" :data="invalidData" @close-dialog-event="closeDialog" @proceed-import-event="proceedImport"></TheInvalidImportDialog>

						<ThePageError @back-event="cancel" :pageError="pageError" v-if="pageError != ''"></ThePageError>
					</div>
					
					<TheFooter></TheFooter>
				</div>
			</form>
		</div>
	</div>
</template>

<script lang="ts">
	import { defineComponent } from "vue";
	import store from "@/store";
	import eliminationSettingApi from "@/api/eliminationsetting-api";
	import statusMixin from "@/mixin/status";
    import exchangeRateMixin from "@/mixin/exchange-rate";
	
	import TheHeader from "@/components/TheHeader.vue";
	import TheFooter from "@/components/TheFooter.vue";
	import TheSidebar from "@/components/TheSidebar.vue";
	import ThePageHeader from "@/components/ThePageHeader.vue";
	import TheTableLoading from "@/components/TheTableLoading.vue";
	import ThePageError from "@/components/ThePageError.vue";
	import TheInvalidImportDialog from "@/components/TheInvalidImportDialog.vue";
	
	export default defineComponent({
		mixins: [statusMixin, exchangeRateMixin],
		components: {
			TheHeader,
			TheFooter,
			TheSidebar,
			ThePageHeader,
			TheTableLoading,
			ThePageError,
			TheInvalidImportDialog
		},
		data() {
			return {
				pageError: (store.getters.error == undefined ? '' : store.getters.error),
				pagination: (store.getters.getCached.page == null ? {currentPage: 1, itemsPerPage: 10, eliminationSettings: [], totalItems: 0} : store.getters.getCached.page.pagination),
				sortingModel: (store.getters.getCached.page == null ? {columnName: "x.name", isAscending: true} : store.getters.getCached.page.sortingModel),
				filterNameModel: (store.getters.getCached.page == null ? {value: ""} : store.getters.getCached.page.filterNameModel),
                filterExchangeRateModel: (store.getters.getCached.page == null ? {value: ""} : store.getters.getCached.page.filterExchangeRateModel),
				filterStatusModel: (store.getters.getCached.page == null ? {value: null} : store.getters.getCached.page.filterStatusModel),
				isLoading: false,
				isImporting: false,
				isExporting: false,
				isDialogVisible: false,
				invalidData:{} as any
			}
		},
		watch: {
			// filterLegalGroupId(newValue: any) {
			// 	this.pagination = {currentPage: 1, itemsPerPage: 10, companies: [], totalItems: 0};
			// 	this.find(1);
			// }
		},
		mounted: function() {
			if (this.pageError == '') {
				this.find(this.pagination.currentPage);
			}
		},
		computed: {
			paginator() {
				return ((this.pagination.currentPage - 1) * this.pagination.itemsPerPage);
			},
			// filterLegalGroupId() {
			// 	return store.getters.getFilterLegalGroupModel != null ? store.getters.getFilterLegalGroupModel.identifier : null;
			// }
		},
		methods: {
			sort(columnName: string) {
				if (this.sortingModel.columnName == columnName) {
					this.sortingModel.isAscending = !this.sortingModel.isAscending;
				}
				
				else {
					this.sortingModel.columnName = columnName;
					this.sortingModel.isAscending = true;
				}
				this.find(1);
			},
			find(page: number) {
				this.isLoading = true;
				
				store.getters.getCached.page = {
					pagination: JSON.parse(JSON.stringify(this.pagination)),
					sortingModel: JSON.parse(JSON.stringify(this.sortingModel)),
					filterNameModel: JSON.parse(JSON.stringify(this.filterNameModel)),
                    filterExchangeRateModel: JSON.parse(JSON.stringify(this.filterExchangeRateModel)),
					filterStatusModel: JSON.parse(JSON.stringify(this.filterStatusModel)),
				};
				
				eliminationSettingApi.eliminationSettingFind({
						paginationModel: {currentPage: page},
						sortingModel: this.sortingModel,
						filterNameModel: this.filterNameModel,
                        filterExchangeRateModel: this.filterExchangeRateModel,
						filterStatusModel: this.filterStatusModel
					})
					.then(response => {
						this.pagination = {currentPage: response.data.currentPage, itemsPerPage: response.data.itemsPerPage, eliminationSettings: response.data.rowSet, totalItems: response.data.totalItems}
						if (store.getters.getCached.page == null) {
							store.getters.getCached.page = {};
						}
						store.getters.getCached.page.pagination = this.pagination;
						this.isLoading = false;
					})
					.catch(error => {
						this.isLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			reset() {
				this.pagination = {currentPage: 1, itemsPerPage: 10, companies: [], totalItems: 0};
				this.sortingModel = {columnName: "x.name", isAscending: true};
				this.filterNameModel = {value: ""};
                this.filterExchangeRateModel = {value: ""};
				this.filterStatusModel = {value: null};
				this.find(1);
			},
			add() {
				this.$router.push("/admin/eliminationsetting/add");
			},
			view(eliminationSetting: any) {
				this.$router.push("/admin/eliminationsetting/view/" + eliminationSetting.identifier);
			},
			importFile(file: any) {
				this.isImporting = true;

				var formData = new FormData();
				formData.append('file', file[0]);

				eliminationSettingApi.eliminationSettingImport(formData)
					.then((response: any) => {
						this.isImporting = false;
						this.invalidData = response.data;
						this.isDialogVisible = true;
					})
					.catch(error => {
						this.isImporting = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			proceedImport(isOverride: boolean) {
				this.isImporting = true;

				let tempInvalidData = JSON.parse(JSON.stringify(this.invalidData));
				
				if (isOverride == false && tempInvalidData.warningCount > 0) {
					tempInvalidData.invalidRows.forEach((invalidRow: any, index: any) => {
						if (invalidRow.type == "Warning") {
							invalidRow.type = "Error";
							return invalidRow;
						}
					});
				}

				eliminationSettingApi.eliminationSettingImportProceed({'invalidData': tempInvalidData})
					.then((response: any) => {
						this.isImporting = false;
						this.$toast.add({severity: "success", summary: "Success", detail: response.message, life: 6000});
						this.isDialogVisible = false;
						this.find(1);
					})
					.catch(error => {
						this.isImporting = false;
						this.isDialogVisible = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			exportFile() {
				this.isExporting = false;

				eliminationSettingApi.eliminationSettingExport({
						filterNameModel: this.filterNameModel,
						filterExchangeRateModel: this.filterExchangeRateModel,
						filterStatusModel: this.filterStatusModel
					})
					.then(response => {
						this.isExporting = false;
					})
					.catch(error => {
						this.isExporting = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			closeDialog() {
				this.isDialogVisible = false;
			}
		}
	});
</script>
